import React, { useState, useEffect } from 'react';
import { WORK_TYPES } from './constants';

const OnboardingStep1 = ({ formData, updateFormData, onNext, onBack }) => {
    const [company, setCompany] = useState(formData.company);
    const [errors, setErrors] = useState({});

    useEffect(() => {
        // Update parent formData when company changes
        updateFormData({ company });
    }, [company]);

    const handleChange = (field, value) => {
        setCompany({ ...company, [field]: value });
        // Clear error for this field
        if (errors[field]) {
            setErrors({ ...errors, [field]: null });
        }
    };

    const handleWorkTypeChange = (type) => {
        const types = company.types_of_work || [];
        const updated = types.includes(type)
            ? types.filter((t) => t !== type)
            : [...types, type];
        setCompany({ ...company, types_of_work: updated });
    };

    const validate = () => {
        const newErrors = {};
        if (!company.display_name || company.display_name.trim() === '') {
            newErrors.display_name = 'Company name is required';
        }
        if (!company.address || company.address.trim() === '') {
            newErrors.address = 'Address is required';
        }
        if (!company.types_of_work || company.types_of_work.length === 0) {
            newErrors.types_of_work = 'Please select at least one work type';
        }
        setErrors(newErrors);
        return Object.keys(newErrors).length === 0;
    };

    const handleNext = () => {
        if (validate()) {
            onNext();
        }
    };

    // Use shared constants for consistency across app
    const workTypes = WORK_TYPES.filter(type => type !== 'Unknown'); // Exclude Unknown for new companies

    return (
        <div className="wizard-step">
            <div className="step-header">
                <h2>Company Information</h2>
                <p>Tell us about your office</p>
            </div>

            <div className="form-group">
                <label>
                    Company/Office Name <span style={{ color: 'red' }}>*</span>
                </label>
                <input
                    type="text"
                    placeholder="e.g., Company 2 - Tempe Office"
                    value={company.display_name}
                    onChange={(e) => handleChange('display_name', e.target.value)}
                />
                {errors.display_name && (
                    <div className="error-message">{errors.display_name}</div>
                )}
            </div>

            <div className="form-group">
                <label>
                    Address <span style={{ color: 'red' }}>*</span>
                </label>
                <textarea
                    placeholder="123 Main St, Tempe, AZ 85281"
                    value={company.address}
                    onChange={(e) => handleChange('address', e.target.value)}
                />
                {errors.address && (
                    <div className="error-message">{errors.address}</div>
                )}
            </div>

            <div className="form-group">
                <label>
                    Tagline <span className="optional-label">(optional)</span>
                </label>
                <input
                    type="text"
                    placeholder="e.g., Building Tomorrow's Infrastructure"
                    value={company.tagline || ''}
                    onChange={(e) => handleChange('tagline', e.target.value)}
                />
            </div>

            <div className="form-group">
                <label>
                    Types of Work <span style={{ color: 'red' }}>*</span>
                </label>
                <div className="checkbox-group">
                    {workTypes.map((type) => (
                        <label key={type}>
                            <input
                                type="checkbox"
                                checked={(company.types_of_work || []).includes(type)}
                                onChange={() => handleWorkTypeChange(type)}
                            />
                            {type}
                        </label>
                    ))}
                </div>
                {errors.types_of_work && (
                    <div className="error-message">{errors.types_of_work}</div>
                )}
            </div>

            <div className="step-footer">
                <button onClick={onBack} className="btn-back">
                    ← Back
                </button>
                <button onClick={handleNext} className="btn-next">
                    Next →
                </button>
            </div>
        </div>
    );
};

export default OnboardingStep1;

